import UserBusiness from '@/entity/UserBusiness/UserBusiness';
import { ElForm } from 'element-ui/types/form';
import _ from 'lodash';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { SlideYUpTransition } from 'vue2-transitions';

@Component({ name: 'ResetUserBusinessPassword', components: { SlideYUpTransition } })
export default class ResetUserBusinessPassword extends Vue {
    private passwordFormRef: ElForm;
    private userID: number;
    private show = false;
    private isLoading = false
    private fullname = '';

    private passwordForm = {
        password: '',
        repeatPassword: ''
    }
    private passwordFormRules = {
        password: [{ required: false, validator: this.validatePassword, trigger: 'change' }],
        repeatPassword: [{ required: false, validator: this.validateRepeatPassword, trigger: 'change' }]
    }

    private validatePassword(rule, value, callback) {
        if (value === '') {
            (<any>this.passwordFormRef.rules).password[0].required = false;
            (<any>this.passwordFormRef.rules).repeatPassword[0].required = false;
        }
        else {
            (<any>this.passwordFormRef.rules).password[0].required = true;
            (<any>this.passwordFormRef.rules).repeatPassword[0].required = true;

            if (this.passwordForm.repeatPassword !== '')
                this.passwordFormRef.validateField('repeatPassword');
        }

        callback();
    }

    private validateRepeatPassword(rule, value, callback) {
        if (value === '' && this.passwordForm.password !== '')
            callback(new Error('Reinserire la password'));
        else if (value !== this.passwordForm.password)
            callback(new Error('Le password non corrispondono'));
        else
            callback();
    }

    public open(user: UserBusiness) {
        this.passwordFormRef.resetFields();
        Object.assign(this, this.initData());

        this.userID = user.ID;
        this.fullname = user.fullname;

        this.show = true;
    }

    private confirmClose() {
        const isChanged = !_.isMatch({ passwordForm: this.passwordForm }, { passwordForm: this.initData().passwordForm });

        if (isChanged) {
            this.$confirm("Ci sono modifiche non salvate, chiudere ugualmente?", "Modifiche non salvate", {
                confirmButtonText: "SÌ",
                cancelButtonText: "Annulla",
                type: "warning",
            })
                .then(() => {
                    this.closeModal();
                })
                .catch(() => {
                    return;
                });
        } else
            this.closeModal();
    }

    private closeModal() {
        this.show = false;
        this.$emit('close');
    }

    private initData() {
        return {
            passwordForm: {
                password: '',
                repeatPassword: ''
            },
            userID: NaN,
            fullname: ''
        }
    }

    private async changePassword() {
        this.isLoading = true;

        try {
            await this.passwordFormRef.validate();

            const psw = await UserBusiness.resetPassword(this.userID, this.passwordForm.password.nullIfEmpty());

            this.$emit('pswChanged', psw);
            this.$message.success({ message: 'Password resettata con successo', showClose: true });
            this.closeModal();
        }
        catch {
            this.$message.error({ message: 'Errore nel reset della password', showClose: true });
        }

        this.isLoading = false;
    }

    mounted() {
        this.passwordFormRef = <ElForm>this.$refs.passwordForm;
    }

    @Watch('show')
    private showChanged(val) {
        const documentClasses = document.body.classList;

        if (val)
            documentClasses.add('modal-open');
        else
            documentClasses.remove('modal-open');
    }
}
